import {springConfigs} from "@cdx/common";
import {css} from "@cdx/ds";
import {useSpring, animated} from "react-spring";
import {progressCircleStyles as styles} from "./ProgressCircle.css";

const ProgressCircle = ({size = 16, progress}: {progress: number; size?: 16 | 20 | 32 | 48}) => {
  const dashArray = 2 * Math.PI * 8;
  const animProps = useSpring({
    strokeDashoffset: dashArray * (1 - Math.max(progress, 0.01)),
    config: springConfigs.quick,
  });

  const asString = `${size}px` as const;
  return (
    <svg
      viewBox="0 0 20 20"
      style={{transform: "rotate(-90deg)"}}
      className={css({width: asString, height: asString, display: "block"})}
    >
      <circle cx={10} cy={10} fill="transparent" r={8} className={styles.bg} strokeWidth={2} />
      <animated.circle
        style={animProps}
        cx={10}
        cy={10}
        fill="transparent"
        r={8}
        className={styles.track}
        strokeWidth={2}
        strokeDasharray={dashArray}
      />
    </svg>
  );
};

export default ProgressCircle;
